// Non-sensitive cookie that signals "a user is logged in on this device".
// Not a session token — just a UI hint for same-domain pages (e.g. www marketing site).
const COOKIE_NAME = 'goaltree_session'
const MAX_AGE = 60 * 60 * 24 * 30 // 30 days

// Share the cookie across the root domain (e.g. app.goaltree.ai → .goaltree.ai)
// so the www marketing site can read it. On localhost there's no subdomain, so
// we omit the domain attribute and let it default to the current hostname.
function rootDomainAttr(): string {
  const parts = window.location.hostname.split('.')
  if (parts.length < 2) return ''
  return `; domain=.${parts.slice(-2).join('.')}`
}

export function setSessionIndicator() {
  document.cookie = `${COOKIE_NAME}=1; max-age=${MAX_AGE}; path=/${rootDomainAttr()}; SameSite=Lax`
}

export function clearSessionIndicator() {
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/${rootDomainAttr()}; SameSite=Lax`
}

export function hasSessionIndicator(): boolean {
  return document.cookie.split(';').some((c) => c.trim().startsWith(`${COOKIE_NAME}=`))
}
